module.exports = __webpack_public_path__ + "media/images/twitter-alt-9aeec12652e5fa287358164296997582.png";